import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { colors } from "../../../style";
import ChartCard from "./ChartCard";
import ChartTooltip from "./ChartTooltip";
import { chart, directionLabels, formatNumber, series } from "./theme";

const KEYS = ["inbound", "outbound", "internal"];

const centre = {
  position: "absolute",
  inset: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  pointerEvents: "none",
};

function DirectionDonut({ daily, style }) {
  const data = KEYS.map((k) => ({
    key: k,
    name: directionLabels[k],
    value: daily.reduce((sum, d) => sum + d[k], 0),
  }));
  const total = data.reduce((sum, d) => sum + d.value, 0);
  const pct = (v) => (total ? Math.round((v / total) * 100) : 0);

  return (
    <ChartCard
      title="Call mix"
      subtitle="Share of calls by direction"
      height={280}
      style={style}
      table={{
        columns: ["Direction", "Calls", "Share"],
        rows: data.map((d) => [d.name, d.value, `${pct(d.value)}%`]),
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <div style={{ flex: 1, minHeight: 0, position: "relative" }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                innerRadius="64%"
                outerRadius="92%"
                paddingAngle={2}
                cornerRadius={4}
                stroke={chart.surface}
                strokeWidth={2}
              >
                {data.map((d) => (
                  <Cell key={d.key} fill={series[d.key]} />
                ))}
              </Pie>
              <Tooltip
                content={
                  <ChartTooltip
                    title={(_, payload) => payload[0].name}
                    rows={(payload) => [
                      { label: "Calls", value: formatNumber(payload[0].value) },
                      { label: "Share", value: `${pct(payload[0].value)}%` },
                    ]}
                  />
                }
              />
            </PieChart>
          </ResponsiveContainer>
          <div style={centre}>
            <div
              style={{ color: colors.text, fontSize: "24px", fontWeight: 600 }}
            >
              {formatNumber(total)}
            </div>
            <div style={{ color: colors.textLight, fontSize: "12px" }}>
              calls
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "18px",
            marginTop: "10px",
          }}
        >
          {data.map((d) => (
            <div key={d.key} style={{ textAlign: "center" }}>
              <div
                style={{
                  color: colors.textMuted,
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "2px",
                    background: series[d.key],
                  }}
                />
                {d.name}
              </div>
              <div
                style={{
                  color: colors.text,
                  fontSize: "15px",
                  fontWeight: 600,
                }}
              >
                {pct(d.value)}%
              </div>
            </div>
          ))}
        </div>
      </div>
    </ChartCard>
  );
}

export default DirectionDonut;
